import CommonButton from 'components/Buttons/CommonButton';
import React from 'react';
import { useSelector } from 'react-redux';
import services from 'services';
import selectors from 'state/selectors';
import utils from 'utils';
import useCheckBeforeAction from '../hooks';
import { actionType } from 'utils/constants';

interface Props {
  disabled?: boolean;
}

const UnlockDocument = (props: Props) => {
  const { disabled } = props;
  const protocol = useSelector(selectors.documents.selectActiveDocumentID);
  const t = utils.intl.useTranslator();
  const { checkDocuments } = useCheckBeforeAction(actionType.UNLOCK_DOCUMENT);

  return (
    <CommonButton
      id="unlock-document-btn"
      action={async () => {
        const docFree = await checkDocuments();
        if (!docFree) return;
        if (protocol) {
          try {
            const response = await services.unlockDocumentByUser(protocol);
            utils.app.notify('success', response.data);
          } catch (e) {
            utils.app.notify('fail', e as string);
          }
        }
      }}
      scope="tertiary"
      value={t('unlock-document')}
      disabled={disabled}
      customIcon="locker"
    />
  );
};

export default UnlockDocument;
